
import TableList from "@components/templates/tablelist";
import { HttpQueryReserveSku } from '@/service/setting';
export default {
    mixins: [TableList],
    props:['initFormData'],
    data() {
        return {
            isMixin: true,
            Searchs: {
                show: true,
                style: "border:none;",
                labelWidth: 'auto',
                align: "left",
            },
        };
    },
    created(){
        console.log(this.initFormData)
    },
    methods: {
        ajaxRequest: HttpQueryReserveSku,
        interceptRequest(params) {
            return params
        },
    },
    computed: {
        SearchsData() {
            return [{
                label: "SKU",
                tag: 'vInput',
                key: 'CN_sku',
                show: true,
            },]
        },
        columns() {
            return [{
                title: "No.",
                type: 'index',
                width: 60,
            }, {
                title: "SKU",
                key: 'sku'
            }, {
                title: this.$t('fbb.inbound.CN_name', { defaultValue: "名称(中文)" }),
                key: 'productName'
            }, {
                title: this.$t('global.common.En_name', { defaultValue: "名称(英文)" }),
                key: 'productNameEn'
            },
            {
                title: '可用库存',
                key: 'inventoryAvailable'
            },
            {
                title: this.$t('global.common.operation', { defaultValue: "操作" }),
                width: 120,
                align: 'center',
                render: (h, { row }) => {
                    return h('vButton', {
                        props: {
                            theme: 'primary'
                        },
                        nativeOn: {
                            click: () => {
                                this.$emit('on-data', row)
                            }
                        }
                    }, this.$t('fbb.inbound.choose', { defaultValue: "选择" }))
                }
            }]
        }
    }

};
